import { TScreenerListItemApiResponse } from '@/types/Screener.types';
import { TSortingParams } from '@/types';
import queryKeys from '@/constants/queryKeys';
import { getScreenersListByUserId } from '@/services/api/requests/assessment';
import { usePagination } from '../usePagination';

const useScreenersByUserId = ({ id, sortingColumn, sortingDirection }: { id: string } & TSortingParams) => {
  return usePagination<TScreenerListItemApiResponse[], { id: string }>({
    query: (page, queryParams, sortingColumn, sortingDirection) =>
      getScreenersListByUserId(page, queryParams, sortingColumn, sortingDirection),
    queryKey: [queryKeys.assessment.screenersByUserId, id],
    sortingColumn: sortingColumn ?? 'Created At',
    sortingDirection,
    queryParams: { id },
  });
};

export default useScreenersByUserId;
